import styled, { css } from 'styled-components';

export const ErrorMessage = styled.span`
  color: #ef5350;
  font-size: 12px;
`;

const common = css`
  border: 1px solid #c3d0dd;
  border-radius: 4px;
  height: 50px;
  padding: 14px;
  font-size: 14px;
  font-family: var(--font-family);

  &::placeholder {
    color: #868e96;
    font-size: 14px;
    font-family: var(--font-family);
  }
`;

export const TextField = styled.input`
  ${common}
`;

export const TextArea = styled.textarea`
  ${common}
`;
